var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-adult-sell-order-detail',{ref:"detail",staticClass:"pt-adult-sell-order-detail__page",attrs:{"id":_vm.id,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }